import { Component, Input, OnInit } from '@angular/core'
import { ProductTypeModel } from 'src/app/shared/product-type-model'

import {
  FUND_LITERATURE,
  LITERATURE_FUND,
  MONTH_END_RETURN_MARKET_ETF,
  MONTH_END_RETURN_NAV,
  PERFORMANCE_MARKET_ETF,
  PERFORMANCE_VALUE,
} from '../../../constants/constant.content'
import { IFilterState } from '../../services/data-filters/models/ifilter-state'
import { ObservableService } from '../../services/observable-service/observable.service'
import { UtilityService } from '../../services/utility-service/utility-service.service'
import { FilterModel } from '../../shared/filter-model'

@Component({
  selector: 'sort-by-type',
  templateUrl: './sort-by-type.component.html',
  styleUrls: ['./sort-by-type.component.scss'],
})
export class SortByTypeComponent implements OnInit {
  constructor(
    private readonly observableService: ObservableService,
    private filterModel: FilterModel,
  ) {}

  @Input() fd3tableContentList: any
  @Input() viewType: string
  protected readonly performance = MONTH_END_RETURN_NAV
  protected readonly monthEndReturnsMarketETF = MONTH_END_RETURN_MARKET_ETF
  protected readonly MONTH_END_RETURN_MARKET_ETF = MONTH_END_RETURN_MARKET_ETF
  protected readonly literature = LITERATURE_FUND
  isBenchmark = false
  isSharedClass = false
  isAllShareClassApplied = false
  navSwitchValue = false

  selectedFilter: any
  displayTypeValue = ''
  isNavMarketPriceApplicable = true
  ngOnInit(): void {
    this.observableService.benchmarkSelectedValue.subscribe(
      (isSelectedBenchMark: boolean) => {
        this.isBenchmark = isSelectedBenchMark
      },
    )

    this.observableService.sharedClassSelectedValue.subscribe(
      (isAllShareClassSelected: boolean) => {
        this.isSharedClass = isAllShareClassSelected
      },
    )
    this.isAllShareClassApplied = true
    this.setAllShareClassSelection()
    this.observableService.viewTypeValue.subscribe((displayTypeName) => {
      this.viewType = displayTypeName
      this.selectedFilter = this.filterModel.setFilter(displayTypeName)
    })
    this.filterModel.telecastProductType.subscribe((value) => {
      this.isETFSelected(value)
    })
  }

  benchmarkClicked() {
    if (this.isBenchmark) {
      this.isBenchmark = false
      this.observableService.changeBenchmarkSelection(false)
    } else {
      this.isBenchmark = true
      this.observableService.changeBenchmarkSelection(true)
    }
  }

  sharedClassClicked() {
    if (this.isSharedClass) {
      this.isSharedClass = false
      this.observableService.changeSharedClassSelection(false)
    } else {
      this.isSharedClass = true
      this.observableService.changeSharedClassSelection(true)
    }
  }

  setAllShareClassSelection() {
    this.observableService.consolidateFiltersObservable.subscribe(
      (filterState: IFilterState) => {
        this.isAllShareClassApplied =
          UtilityService.isAllShareClassOptionApplicable(filterState)
      },
    )
  }
  navSwitchAccessibility(data: any) {
    this.navSwitchValue = data.checked
  }

  onViewTypeChange() {
    this.checkIfPerformanceSelected()
    if (this.selectedFilter.selectedTab === FUND_LITERATURE) {
      this.displayTypeValue = FUND_LITERATURE
    }
    this.observableService.changeViewTypeValue(this.displayTypeValue)
  }

  checkIfPerformanceSelected() {
    if (this.selectedFilter.selectedTab === PERFORMANCE_VALUE) {
      if (this.selectedFilter.returnType === '') {
        this.selectedFilter.returnType = MONTH_END_RETURN_NAV
      }
      this.displayTypeValue =
        this.selectedFilter.toggleOn && this.isNavMarketPriceApplicable
          ? PERFORMANCE_MARKET_ETF
          : MONTH_END_RETURN_NAV
    }
  }

  toggleNavMarketPrice() {
    const DELAY = 500
    this.selectedFilter.toggleOn = !this.selectedFilter.toggleOn
    this.observableService.changeToggleOnValue(this.selectedFilter.toggleOn)
    setTimeout(() => {
      this.onViewTypeChange()
    }, DELAY)
  }

  isETFSelected(receivedData: ProductTypeModel) {
    this.isNavMarketPriceApplicable =
      receivedData.productType.etf.value === true ||
      (receivedData.productType.mf.value === false &&
        receivedData.productType.etf.value === false &&
        receivedData.productType.colTrust.value === false)
    this.onViewTypeChange()
  }
}
